export interface ExperienceExtraOccurrence {
  price?: number;
  perPax?: boolean;
  adults?: number;
  adultCount?: number;
  childrenBirthdates?: unknown[];
}

export interface ExperiencePriceBase {
  price?: number;
  currency?: string;
}

export interface ExperiencePrice {
  price: number;
  currency?: string;
}

export function getExperienceExtraAmount(
  extra: ExperienceExtraOccurrence | null | undefined,
): number {
  const unitPrice = extra?.price ?? 0;

  if (!extra?.perPax) {
    return unitPrice;
  }

  const paxCount =
    (extra?.adults ?? extra?.adultCount ?? 0) +
    (extra?.childrenBirthdates?.length ?? 0);

  return unitPrice * paxCount;
}

export function sumExperienceExtras(
  extras: ExperienceExtraOccurrence[] | null | undefined,
): number {
  return (extras ?? []).reduce(
    (sum, extra) => sum + getExperienceExtraAmount(extra),
    0,
  );
}

// The experience price includes its extras: every selected occurrence, on
// any day of the instance, adds to the program's own rate — counted once per
// traveller when it is priced per pax. Previously duplicated inline in each
// app's own pricing effect (ComposeDayExperience.js).
export function priceExperience(
  basePrice: ExperiencePriceBase | null | undefined,
  extras: ExperienceExtraOccurrence[] | null | undefined,
): ExperiencePrice | null {
  if (basePrice?.price === undefined) {
    return null;
  }

  return {
    price: basePrice.price + sumExperienceExtras(extras),
    currency: basePrice.currency,
  };
}
